import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { type FC, useState } from 'react';
import { StorageImage } from '@/components/atoms/StorageImage';
const DEFAULT_PLACEHOLDER_IMAGE = '/images/anonymous2.png';
const DEFAULT_BACKGROUND_GRADIENT = 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)';
export interface CelebrityCardProps {
  /**
   * URL ссылки на знаменитость
   */
  href: string;
  /**
   * Имя знаменитости
   */
  firstName: string;
  /**
   * Фамилия знаменитости
   */
  lastName: string;
  /**
   * Количество активностей
   */
  activitiesCount: number;
  /**
   * Количество опыта
   */
  experiencesCount: number;
  /**
   * URL изображения знаменитости
   */
  imageUrl?: string;
  /**
   * Альтернативный текст для изображения
   */
  imageAlt?: string;
  /**
   * Обработчик клика по карточке
   */
  onClick?: () => void;
}
export const CelebrityCard: FC<CelebrityCardProps> = t0 => {
  const $ = _c(46);
  const {
    firstName,
    lastName,
    activitiesCount,
    experiencesCount,
    imageUrl,
    href
  } = t0;
  const [src, setSrc] = useState(imageUrl || DEFAULT_PLACEHOLDER_IMAGE);
  const t = useTranslations("common.celebrities.card");
  let t1;
  if ($[0] !== firstName) {
    t1 = <div className="truncate">{firstName}</div>;
    $[0] = firstName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = lastName || "\u3164";
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="truncate">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className={"uppercase min-h-[\n      44px] lg:min-h-[58px] lg:mb-1.5 text-[#EBECFE] font-bold md:text-[20px] px-2 py-1.5 text-[14px] lg:text-[20px] leading-[130%]"}>{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${firstName} ${lastName}`;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setSrc(DEFAULT_PLACEHOLDER_IMAGE);
    t7 = [{
      media: "(min-width: 1280px)",
      width: 272,
      height: 272,
      resize: "cover"
    }, {
      media: "(min-width: 768px)",
      width: 156,
      height: 156,
      resize: "cover"
    }, {
      media: "(min-width: 0px)",
      width: 156,
      height: 156,
      resize: "cover"
    }];
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== src || $[10] !== t5) {
    t8 = <StorageImage src={src} alt={t5} className="h-full w-full object-cover " withBlur={true} onError={t6} sources={t7} />;
    $[9] = src;
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="object-contain" style={{
      background: DEFAULT_BACKGROUND_GRADIENT
    }} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `flex flex-col lg:p-1 ${activitiesCount === 0 && experiencesCount === 0 ? "opacity-0" : ""}`;
  let t11;
  if ($[13] !== t) {
    t11 = t("activities");
    $[13] = t;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11) {
    t12 = <span className="whitespace-nowrap font-semibold">{t11}:</span>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== activitiesCount) {
    t13 = <span className="ml-1  text-right font-semibold">{activitiesCount}</span>;
    $[17] = activitiesCount;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12 || $[20] !== t13) {
    t14 = <div className="flex items-center  text-[10px] leading-[130%] text-[#EBECFE] lg:text-[16px]">{t12}{t13}</div>;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t) {
    t15 = t("experiences");
    $[22] = t;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15) {
    t16 = <span className="whitespace-nowrap font-semibold">{t15}:</span>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== experiencesCount) {
    t17 = <span className="ml-1 text-right font-semibold">{experiencesCount}</span>;
    $[26] = experiencesCount;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <div className="flex items-center text-[10px] leading-[130%] text-[#EBECFE] lg:text-[16px]">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t18) {
    t19 = <div className={t10}>{t14}{t18}</div>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="z-10 w-[32px] h-[32px] lg:w-[56px] lg:h-[56px] flex items-center justify-center p-2 lg:p-2.5 rounded-full bg-[#352E7359] filter backdrop-blur-[5.6px]"><svg className="w-[12px] h-[12px] lg:w-[17px] lg:h-[17px]" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="icon"><path d="M1 15.5833L15.5833 1M15.5833 1H1M15.5833 1V15.5833" stroke="#8082B2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t19) {
    t21 = <div className="z-10 absolute bottom-1 lg:bottom-0 left-0 right-0 flex items-center justify-between  px-2">{t19}{t20}</div>;
    $[36] = t19;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t21 || $[39] !== t8) {
    t22 = <div className="relative flex-1 mt-auto rounded-[12px] lg:rounded-[16px] overflow-hidden">{t8}{t9}{t21}</div>;
    $[38] = t21;
    $[39] = t8;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="w-full opacity-70 group-hover:opacity-100 transition-opacity duration-300 h-[24%] absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#352E73] to-transparent" />;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== href || $[43] !== t22 || $[44] !== t4) {
    t24 = <Link href={href} className="group flex flex-col p-1.5 lg:p-2 relative aspect-[168/216] lg:aspect-[288/352] w-full cursor-pointer overflow-hidden rounded-[16px] bg-[#31324B59] lg:rounded-[20px]">{t4}{t22}{t23}</Link>;
    $[42] = href;
    $[43] = t22;
    $[44] = t4;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  return t24;
};